import {
    FormattedIdentityProviderDetails,
    IdentityProviderDetails,
    IdentityProviderCategory,
    IdentityProviderClassification,
    IdentityProviderCompany,
    IdentityProviderLoa,
    IdentityProviderProtocol,
    IdentityProviderScheme,
    IdentityProviderDetailsPermissions
} from "@idw-types/data/identity-providers";
import { formatIdentityProviderDetailsCompanyIDPInfo } from "./identity-provider-details-company-idp-info-formatter";

export const formatIdentityProviderDetails = (
    identityProviderDetails: IdentityProviderDetails,
    categories: Array<IdentityProviderCategory>,
    classifications: Array<IdentityProviderClassification>,
    companies: Array<IdentityProviderCompany>,
    loas: Array<IdentityProviderLoa>,
    protocols: Array<IdentityProviderProtocol>,
    schemes: Array<IdentityProviderScheme>
): FormattedIdentityProviderDetails => {
    const category = categories.find(cat => cat.key === identityProviderDetails.category);
    const classification = classifications.find(cla => cla.id === identityProviderDetails.classificationID);
    const company = companies.find(com => com.id === identityProviderDetails.companyID);
    const loa = loas.find(loa => loa.key === identityProviderDetails.loa);
    const protocol = protocols.find(pro => pro.key === identityProviderDetails.protocol);
    const companyIDPInfo = formatIdentityProviderDetailsCompanyIDPInfo(
        identityProviderDetails.companyIDPInfo,
        schemes
    );
    return {
        category: category,
        classification: classification,
        code: identityProviderDetails.code,
        company: company,
        companyIDPInfo: companyIDPInfo,
        id: identityProviderDetails.id,
        loa: loa,
        protocol: protocol,
        name: identityProviderDetails.name,
        permissions: { ...(identityProviderDetails.permissions || {} as IdentityProviderDetailsPermissions) }
    };
};